var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"v-range-slider",attrs:{"type":"range"}},'input',{ min: _vm.min, max: _vm.max, step: _vm.step, value: _vm.value },false),{ input: _vm.input, change: _vm.change }))}
var staticRenderFns = []

export { render, staticRenderFns }